import { defineMessages } from "react-intl";

export const messages = defineMessages({
  pageType: {
    id: "OUX4LB",
    defaultMessage: "Model type",
    description: "input label",
  },
  selectPageType: {
    id: "QJJke/",
    defaultMessage: "Select a model type",
    description: "dialog header",
  },
});
